// extracted by mini-css-extract-plugin
export default {"topbarMain":"Topbar_topbarMain__JFqeL","logo":"Topbar_logo__JxuPy"};